import { imgixHost } from 'src/config'
import GlobalWidget from 'src/models/global-widget/GlobalWidget'
import Model, { ID, Integer, LocalizedJsonObject, MODEL_LEVEL } from 'src/models/model'
import Librariable from 'src/models/model/concerns/Librariable'
import Navigation from 'src/models/page/Navigation'

export const TYPES = {
  FOOTER: 'footer'
}
TYPES.ALL = _.values(TYPES)
Object.freeze(TYPES)

export const fontSizeOptions = [
  { value: 'h1', label: 'H1' },
  { value: 'h2', label: 'H2' },
  { value: 'h3', label: 'H3' },
  { value: 'h4', label: 'H4' },
  { value: 'h5', label: 'H5' },
  { value: 'h6', label: 'H6' },
  { value: 'subtitle2', label: 'Subtitle (Small)' },
  { value: 'body1', label: 'Body Text (Regular)' },
  { value: 'body2', label: 'Body Text (Small)' },
  { value: 'caption', label: 'Caption (Very Small Text)' },
  { value: 'overline', label: 'Overline (Spaced Small Text)' }
]

export const DISPLAY_ITEMS = {
  NAME: 'Name',
  LOGO: 'Logo',
  CONTACT_INFO: 'Contact Info',
  MAIN_LINKS: 'Main Links',
  NAVIGATION_LINKS: 'Navigation Links',
  MARKET_SIGNUP: 'Market Signup Form',
  SOCIAL_ICONS: 'Social Icons',
  CUSTOM_IMAGE: 'Custom Image',
  CUSTOM_TEXT: 'Custom Text'
}
DISPLAY_ITEMS.ALL = _.values(DISPLAY_ITEMS)
Object.freeze(DISPLAY_ITEMS)

export const socialIconsColorOptions = [
  { value: 'white', label: 'White' },
  { value: 'black', label: 'Black' },
  { value: 'grey', label: 'Grey' },
  { value: 'full', label: 'Full Color' }
]

export const TEXT_FIELD_TYPES = {
  OUTLINED: 'Standard',
  ROUNDED: 'Rounded',
  SQUARE: 'Square',
  UNDERLINE: 'Underline'
}
TEXT_FIELD_TYPES.ALL = _.values(TEXT_FIELD_TYPES)
Object.freeze(TEXT_FIELD_TYPES)

export const WIDTH_OPTIONS = {
  FULL_WIDTH: '12',
  HALF_WIDTH: '6',
  ONE_THIRD_WIDTH: '4',
  TWO_THIRDS_WIDTH: '8',
  ONE_FOURTH_WIDTH: '3',
  THREE_FOURTHS_WIDTH: '9',
  ONE_SIXTH_WIDTH: '2',
  FIVE_SIXTHS_WIDTH: '10'
}
WIDTH_OPTIONS.ALL = _.values(WIDTH_OPTIONS)
WIDTH_OPTIONS.OPTIONS = _.map(WIDTH_OPTIONS.ALL, value => ({ value, label: _.startCase(_.lowerCase(_.findKey(WIDTH_OPTIONS, option => option === value))) }))
Object.freeze(WIDTH_OPTIONS)

export default class GlobalWidgetBlock extends Model {
  static name = 'GlobalWidgetBlock'

  static deletable = true
  static duplicatable = true
  static versioned = true

  static level = MODEL_LEVEL.SITE

  static employeeRequiredPermissionCategories = [Model.permissionCategories.SiteContent]

  static define () {
    this.concerns = [Librariable]

    this.fields = {
      id: {
        type: ID,
        required: true
      },
      globalWidget: {
        type: GlobalWidget,
        reference: true,
        output: true
      },
      name: {
        type: String,
        required: true,
        translatable: true
      },
      type: {
        type: String,
        required: true
      },
      displayOrder: {
        type: Integer,
        default: 100
      },
      config: {
        type: LocalizedJsonObject,
        mergeDefault: true,
        default () {
          return {
            width: '',
            displayItems: [],
            image: null,
            fillContainer: false,
            text: '',
            fontSize: 'body2',
            collectName: false,
            collectConsent: false,
            textFieldType: TEXT_FIELD_TYPES.OUTLINED,
            outlineTextField: false,
            socialIconsColor: 'full'
          }
        },
        translatables: ['text']
      },
      navigations: {
        type: [Navigation],
        output: true
      },
      navigationIds: {
        type: [ID],
        default: () => ([])
      }
    }

    this.computed = {
      imageUrl () {
        if (_.isEmpty(this.config.image)) return null

        return `${imgixHost}/${this.config.image}?fm=jpeg&auto=format`
      }
    }
  }
}
